/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/jsx-props-no-spreading */
import * as React from 'react';
import PageTitle from '@/components/PageTitle';
// import card from '@assets/account_setting_card.svg';
// import { useNavigate } from 'react-router-dom';
import { PrimaryTabs } from '@components/PrimaryTabs';
// import CloseBtn from '@assets/close.svg';
// import InfoTip from '@assets/info-tip.svg';
import Payments from './Payments';
import Reimbursements from './Reimbursements';

// import Empty from './Empty';
import classes from './index.module.css';
import { billingTabs } from './const';
// import PaymentCard from './PaymentCard';
import './index.css';

// const MODAL_TIPS = 'We\'ve switched to a new billing method using invoices. Access your billing details under "Download details" in the Action column. For historical payment details, click "View history" below. Please make sure you\'ve connected a valid US bank account or Credit/Debit card in the Account Setting page.';

export default function Page() {
  // const { pathname } = window.location;
  const [billingTab, setBillingTab] = React.useState(0);
  // const [tipDisplay, setTipDisplay] = React.useState(true);
  // const navigate = useNavigate();

  const onTabChange = (event, newTabIndex) => {
    // navigate(newTabIndex === 2 ? '/billing/account-settings' : '/billing');
    setBillingTab(newTabIndex);
  };

  return (
    <div className={classes.main}>
      {/* {tipDisplay && (
        <div className={classes.header_tips}>
          <img src={InfoTip} alt="" />
          <span>{MODAL_TIPS}</span>
          <img className={classes.close_btn} src={CloseBtn} alt="" onClick={() => setTipDisplay(false)} />
        </div>
      )} */}

      <PageTitle title="Billing">
      </PageTitle>
      <PrimaryTabs tabIndex={billingTab} onTabChange={onTabChange} tabList={billingTabs} />
      {billingTab === 0
        && (
          <div className={classes.container}>
            <Payments />
          </div>
        )}

      {billingTab === 1
        && (
          <div className={classes.container}>
            <Reimbursements />
          </div>
        )}

      {/* {billingTab === 2 && (
        <div className={classes.account_settings}>
          <PaymentCard />
          <div className={classes.illustration}>
            <div className={classes.illustration_title}>
              Why do I need to add a payment account?
            </div>
            <ul className={classes.illustration_ul}>
              <li className={classes.illustration_li}>Because Seel uses the payment account that you connect to collect the Seel fees that your shoppers pay</li>
            </ul>
            <div className={classes.illustration_title}>
              Here is how Seel works:
            </div>
            <ul className={classes.illustration_ul}>
              <li className={classes.illustration_li}>
                Shoppers buy Seel during the checkout process on your website, and you collect the fee as part of the order
              </li>
              <li className={classes.illustration_li}>
                Seel then collects the fee from you as a pass-through
              </li>
              <li className={classes.illustration_li}>
                Seel does not charge you any additional fees
              </li>
            </ul>
            <img className={classes.account_settings_img} src={card} alt="" />

          </div>
        </div>
      )} */}
    </div>

  );
}
